import { render } from "./UpdateVendorServiceModal.vue?vue&type=template&id=18c874f0"
import script from "./UpdateVendorServiceModal.vue?vue&type=script&lang=js"
export * from "./UpdateVendorServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__